import React, { useEffect, useState } from "react";
import Utils from "../../utils/utils";

const CourseDetails = ({ student }) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  });
  return (
    <div
      className={`p-2 border rounded-lg shadow-sm w-full transition-transform duration-700 ease-in-out transform ${
        isVisible
          ? "translate-x-0 opacity-100"
          : "translate-x-[-100%] opacity-0"
      }`}
      bkl="CourseDetails"
      key="CourseDetails"
    >
      <div className="mt-1 md:flex mb-4">
        <div className="flex flex-col gap-2 justify-center">
          <div className="flex gap-2 items-center flex-wrap">
            <h1 className="font-bold text-2xl">
              {Utils.getFullCourseName(student.course)}
            </h1>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2  gap-4 z-30">
        <div className="border bg-[#FFFFFF] rounded-lg p-3 ">
          <div className="flex justify-between items-center">
            <p className="text-[#0A0103] px-3  font-semibold text-[14px] leading-6 ">
              Batch
            </p>
            {/* <p className="text-[#3470E4] cursor-pointer text-[12px] font-semibold leading-4 hover:text-blue-600/75">
              EDIT
            </p> */}
          </div>
          <div className="">
            <input
              type="string"
              className="bg-inherit w-[100%] border-none px-3 py-2 truncate"
              value={student.batch}
              disabled
            />
          </div>
          <div className="flex flex-row-reverse">
            {/* <button
              className="rounded-lg gap-[10px] text-[#FFFFFF]  bg-[#3470E4] bg-blue-700 hover:bg-blue-800 uppercase hidden uppercase  cursor-pointer px-4 py-2"
              type="button"
            >
              Save
            </button> */}
          </div>
        </div>

        <div className="border   bg-[#FFFFFF] rounded-lg p-3 ">
          <div className="flex justify-between items-center">
            <p className="text-[#0A0103] px-3  font-semibold text-[14px] leading-6 ">
              Serial Number
            </p>
            {/* <p className="text-[#3470E4] cursor-pointer text-[12px] font-semibold leading-4 hover:text-blue-600/75">
              EDIT
            </p> */}
          </div>
          <div className="">
            <input
              type="text"
              placeholder="Serial Number"
              className="bg-inherit w-[100%] border-none px-3 py-2 truncate"
              value={student.serialNumber}
              disabled
            />
          </div>
          <div className="flex flex-row-reverse">
            <button
              className="rounded-lg gap-[10px] text-[#FFFFFF]   bg-blue-700 hover:bg-blue-800 uppercase hidden uppercase  cursor-pointer px-4 py-2"
              type="button"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetails;
